<div *ngIf="isTemplate; else regular">
  <ng-container *ngTemplateOutlet="item"></ng-container>
</div>
<ng-template #regular>
  <div class="jaspero__confirmation_dialog-data" style="display: inline;" [innerHTML]="item"></div>
</ng-template>



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/@systemic/ng-confirmations/components/variable-content/variable-content.component.html